<template>
  <div class="main">
    <div>
      <!--      <h1>AI-Alerter</h1>-->
      <!--      <el-form :model="form" label-position="top" label-width="80px" ref="form">-->
      <!--        <el-form-item label="用户名">-->
      <!--          <el-input v-model="form.username"></el-input>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item label="密码">-->
      <!--          <el-input type="password" v-model="form.password"></el-input>-->
      <!--        </el-form-item>-->
      <!--        <el-form-item class="login-btn">-->
      <!--          <el-button @click="Login" size="medium" style="width: 150px" type="primary">登录</el-button>-->
      <!--          <el-button @click="register" size="medium" style="width: 150px" type="info">注册</el-button>-->
      <!--        </el-form-item>-->
      <!--      </el-form>-->
      <!--      <el-button @click="WPSLogin" size="big" style="height: 50px;width: 250px" type="primary">wps账号登录</el-button>-->


    </div>
  </div>
</template>

<script>

import {Apis} from "@/api";
import {Utils} from "@/utils/utils";

export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    }
  },
  methods: {

    // async Login() {
    //   const user = await Apis.User.login(this.form.username, this.form.password)
    //   if (user) {
    //     Utils.SetUser(user)
    //
    //     // 如果用户尚未加入任何部门，跳转到部门初始化页面
    //     const response = await Apis.Team.numTeam()
    //     // console.log(response)
    //
    //     if (response.errno === 0) {
    //       if (response.data["teamNum"] === 0) {
    //         this.$router.push({name: "initTeam"})
    //       } else {
    //         window.location.href = "/"
    //       }
    //     }
    //   }
    // },
    // async register() {
    //   window.location.href = "/register"
    // },
    //
    // async WPSLogin() {
    //   console.log("将要跳到wps授权页面")
    //   window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri=https://ai-alerter.wps.cn/&scope=user_info"
    // }
  },

  created() {
    // window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri=https://ai-alerter-test.wps.cn/&scope=user_info"

    // console.log("将要延时x秒跳转：")
    // setTimeout(() => {
    //   window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri=https://ai-alerter.wps.cn/&scope=user_info"
    //
    // }, 10000)
      // window.location.href = "https://openapi.wps.cn/oauthapi/v2/authorize?appid=AK20210507FUOARL&response_type=code&redirect_uri=https://ai-alerter.wps.cn/&scope=user_info"

  },

}
</script>
<style scoped>
h1 {
  text-align: center;
}

.main {
  display: flex;
  justify-content: center;
}

.login-btn {
  text-align: center;
}
</style>